import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MiaV3Service {
  constructor(private http: HttpClient) {}

  obtenhaMetricas(dias: number): Promise<{ dias: number, resumo: any, motivos: any[] }> {
    return this.http.get('/miav3/metricas', { params: { dias: String(dias) } }).toPromise()
      .then((resposta: any) => ({
        dias: resposta?.dias || dias,
        resumo: resposta?.resumo || null,
        motivos: resposta?.motivos || []
      }));
  }

  obtenhaConversas(busca?: string): Promise<any[]> {
    const params: any = {};
    if (busca) params.busca = busca;

    return this.http.get('/miav3/conversas', { params }).toPromise()
      .then((resposta: any) => resposta?.conversas || []);
  }

  obtenhaTurnos(conversaId: number): Promise<{ conversa: any, turnos: any[] }> {
    return this.http.get(`/miav3/conversas/${conversaId}/turnos`).toPromise()
      .then((resposta: any) => ({ conversa: resposta?.conversa, turnos: resposta?.turnos || [] }));
  }

  marqueConversaComoLida(conversaId: number): Promise<any> {
    return this.http.post(`/miav3/conversas/${conversaId}/lida`, {}).toPromise();
  }

  assumaConversa(conversaId: number): Promise<any> {
    return this.http.post(`/miav3/conversas/${conversaId}/assumir`, {}).toPromise();
  }

  devolvaConversa(conversaId: number): Promise<any> {
    return this.http.post(`/miav3/conversas/${conversaId}/devolver`, {}).toPromise();
  }

  respondaConversa(conversaId: number, texto: string): Promise<any> {
    return this.http.post(`/miav3/conversas/${conversaId}/responder`, { texto }).toPromise();
  }

  envieTurnoSimulador(telefone: string, mensagem: string, simularPedidoAberto = false): Promise<any> {
    return this.http.post('/miav3/simulador/turno', { telefone, mensagens: [mensagem], simularPedidoAberto }).toPromise();
  }

  obtenhaOpcoesCheckout(): Promise<any> {
    return this.http.get('/miav3/simulador/checkout/opcoes').toPromise();
  }

  obtenhaEnderecosCheckout(): Promise<any> {
    return this.http.get('/miav3/simulador/checkout/enderecos').toPromise();
  }

  busqueCep(cep: string): Promise<any> {
    return this.http.get(`/miav3/simulador/checkout/cep/${cep}`).toPromise();
  }

  calculeTaxaCheckout(endereco: any, valor: number): Promise<any> {
    return this.http.post('/miav3/simulador/checkout/taxa', { endereco, valor }).toPromise();
  }

  envieLocalizacaoCheckout(telefone: string): Promise<any> {
    return this.http.post('/miav3/simulador/checkout/localizacao', { telefone }).toPromise();
  }

  /** Evento do checkout conversacional (iniciar/clique/texto/localização) → ações. */
  envieEventoCheckout(telefone: string, evento: any): Promise<any> {
    return this.http.post('/miav3/simulador/checkout/evento', { telefone, evento }).toPromise();
  }

  /** Confirmação final do wizard de pagamento (modo/endereço vêm do estado no servidor). */
  confirmeCheckout(dados: { telefone: string; formaDePagamentoId: number; trocoPara?: number }): Promise<any> {
    return this.http.post('/miav3/simulador/checkout/confirmar', dados).toPromise();
  }

  finalizeCheckout(dados: { telefone: string; modo: string; formaDePagamentoId: number;
                            trocoPara?: number; nomeContato?: string; endereco?: any }): Promise<any> {
    return this.http.post('/miav3/simulador/checkout', dados).toPromise();
  }
}
